import { useEffect, useRef } from 'react';
import isEqual from 'lodash.isequal';
/**
 * Custom hook similar to useEffect, but with deep comparison on dependencies.
 *
 * This hook is useful when you have complex objects in your dependency array and
 * you want the effect to run only when there is an actual change in the deep values of the dependencies,
 * not just reference changes.
 *
 * @template T - Extends DependencyList to ensure the type is compatible with React's dependency list for effects.
 * @param {EffectCallback} callback - The effect callback function that will run when dependencies change.
 * @param {T} dependencies - An array of dependencies for this effect. This can include complex objects.
 *
 * @example
 * useDeepEffect(() => {
 *   // Effect logic here.
 * }, [complexObject]);
 */
export function useDeepEffect(callback, dependencies) {
    var currentDependenciesRef = useRef();
    if (!isEqual(currentDependenciesRef.current, dependencies)) {
        currentDependenciesRef.current = dependencies;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, [currentDependenciesRef.current]);
}
